import { render } from "./CanvasContainer.vue?vue&type=template&id=13aa26ba&scoped=true&ts=true"
import script from "./CanvasContainer.vue?vue&type=script&lang=ts"
export * from "./CanvasContainer.vue?vue&type=script&lang=ts"

import "./CanvasContainer.vue?vue&type=style&index=0&id=13aa26ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13aa26ba"]])

export default __exports__